<div class="container-fluid h-100 px-0">
  <ngx-loading [show]="loading" ></ngx-loading>
  <app-generic-photo-gallery *ngIf="patient" [patient]="patient" ></app-generic-photo-gallery>
</div>
